<template>
    <router-view>
        
    </router-view>
</template>
<script>

export default{
    layout:'teacher'
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/teacher/index.vue